







































































import { Component, Prop, Emit, Ref } from 'nuxt-property-decorator'
import { uniqueId, each } from 'lodash'
import { ComponentVue } from '@/base'
import { appStore } from '@/store'
import { masker } from '@/utils'

@Component({
  components: {}
})
export default class AtomTextField extends ComponentVue {
  @Ref()
  atomTextField!: any

  @Prop({ type: String })
  id!: string

  @Prop({ type: String })
  name!: string

  @Prop({ type: String })
  value!: string

  @Prop({ type: Number })
  width!: number

  @Prop({ type: String })
  placeholder!: string

  @Prop({ type: Boolean, default: false })
  autofocus!: boolean

  @Prop({ type: Boolean })
  small!: boolean

  @Prop({ type: Boolean })
  large!: boolean

  @Prop({ type: String })
  label!: string

  @Prop({ type: Boolean })
  solo!: boolean

  @Prop({ type: Boolean })
  filled!: boolean

  @Prop({ type: Number })
  counter!: number

  @Prop({ type: Boolean })
  clearable!: boolean

  @Prop({ type: String })
  appendIcon!: string

  @Prop({ type: String })
  appendOuterIcon!: string

  @Prop({ type: String })
  prependIcon!: string

  @Prop({ type: String })
  prependInnerIcon!: string

  @Prop({ type: String })
  prefix!: string

  @Prop({ type: String })
  suffix!: string

  @Prop({ type: String, default: '' })
  type!: string

  @Prop({ type: Boolean, default: true })
  hideDetails!: boolean

  @Prop({ type: String })
  maxlength!: string

  @Prop({ type: Boolean, default: false })
  disabled!: boolean

  @Prop({ type: String, default: '' })
  mask!: string

  @Prop({ type: Boolean, default: false })
  erasable!: boolean

  @Prop({ type: Boolean, default: false })
  erase!: boolean

  @Prop({ type: Array })
  rules!: any

  @Prop({ type: Boolean, default: false })
  error!: boolean

  @Prop({ type: String, default: '' })
  errorMessage!: string

  @Prop({ type: Boolean, default: false })
  rightAlign!: boolean

  @Prop({ type: Number, default: 20 })
  eraseIconSize!: number

  @Prop({ type: Boolean, default: false })
  imeOn!: boolean

  @Prop({ type: Boolean, default: false })
  imeOff!: boolean

  @Prop({ type: String, default: '' })
  min!: string

  @Prop({ type: String, default: '' })
  max!: string

  @Prop({ type: Number, default: 500 })
  emitIntervalMs!: number

  @Prop({ type: Boolean, default: false })
  kana!: boolean

  @Prop({ type: Boolean, default: false })
  disabledErase!: boolean

  isEmit: boolean = true

  get inputType(): string {
    return this.type !== '' ? this.type : 'text'
  }

  get styles(): object {
    const obj = {
      width: '100%'
    }
    if (this.width !== undefined) {
      obj.width = this.width + 'px'
    }
    return obj
  }

  get eraseButtonStyle(): object {
    return {
      'pointer-events': this.disabled || this.disabledErase ? 'none' : 'auto'
    }
  }

  get eraseStyles(): object {
    const obj = {
      'font-size': this.eraseIconSize + 'px',
      width: '100%'
    }
    if (this.width !== undefined) {
      obj.width = this.width + 'px'
    }
    return obj
  }

  get classes(): object {
    return {
      [this.uniqueName]: true,
      'right-align': this.rightAlign,
      small: this.small,
      large: this.large
    }
  }

  get uniqueName(): string {
    return uniqueId('atom-text-field')
  }

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get _filled(): boolean {
    return this.filled || this.erase
  }

  get _disabled(): boolean {
    return this.disabled || this.erase
  }

  get eraseButtonColor() {
    return this.erase ? '#4769CB' : 'grey lighten-1'
  }

  mounted(): void {
    const elements: any = document.getElementsByClassName(this.uniqueName)[0]
      ?.children

    each(elements, element => {
      if (element.className === 'v-input__control') {
        each(element.children[0].children[0].children, targetElement => {
          if (targetElement.className === 'v-text-field__suffix') {
            targetElement.style.fontSize = this.fontSize - 1 + 'px'
          } else {
            targetElement.style.fontSize = this.fontSize + 'px'
          }
        })
      }
    })

    if (this.autofocus) {
      this.focus()
    }
  }

  focus(): void {
    // this.debug('focus()')
    this.$nextTick(() => {
      if (this.id) {
        const elem = document.getElementById(this.id)
        if (elem) {
          elem.focus()
        }
      }
    })
  }

  @Emit('click')
  onClick() {}

  @Emit('click:append')
  onClickAppend() {}

  @Emit('click:append-outer')
  onClickAppendOuter() {}

  @Emit('click:erase')
  onEraseButtonClick() {}

  onKeydownEnter() {
    if (this.isEmit) {
      this.$emit('keydown:enter')
      this.isEmit = false

      setTimeout(() => (this.isEmit = true), this.emitIntervalMs)
    }
  }

  @Emit('keydown:up')
  onKeydownUp() {}

  @Emit('keydown:down')
  onKeydownDown() {}

  @Emit('keydown:left')
  onKeydownLeft() {}

  @Emit('keydown:right')
  onKeydownRight() {}

  @Emit('keydown:tab')
  onKeydownTab() {}

  @Emit('blur')
  onBlur() {}

  onInput(value: string | null) {
    if (value === null) value = ''

    if (this.mask) {
      const maskedValue = masker(value, this.mask, true)
      if (this.value === maskedValue) {
        return
      }
      this.$emit('input', maskedValue)
    } else {
      this.$emit('input', value)
    }
  }

  onChange(value: string | null) {
    if (value === null) value = ''

    if (this.mask) {
      const maskedValue = masker(value, this.mask, true)
      this.$emit('change', maskedValue)
    } else {
      this.$emit('change', value)
    }
  }

  onFocus() {
    if (this.imeOff || this.mask) {
      this.$webSocket.sendImeOffMessage()
      return
    }

    this.$webSocket.sendImeOnMessage({
      kana: this.kana
    })
  }
}
